<div class="lead-drop-block">
  <div class="lead-text" *ngIf="!blockElement?.isActiveForEdit"
    [innerHTML]="getcontentWithDangerHTml(blockElement?.data)"></div>
  <div *ngIf="blockElement?.isActiveForEdit" class="lead-text">
    <div class="NgxEditor__Wrapper ">
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
      <ngx-editor [editor]=" editor" [ngModel]="blockElement.data" (ngModelChange)="onChange($event)" [disabled]="false"
        [placeholder]="'Type here...'"></ngx-editor>
    </div>
  </div>
</div>